/* eslint-disable import/prefer-default-export */
import { useLocation } from 'react-router-dom';

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}
